import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(panel => ({
        value: panel.id,
        label: panel.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      try {
        const {data} = await axios.get('v1/intelbras/panels', {params});

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching items:', error);
        return [];
      }
    },
    async add(_, params) {
      const {data} = await axios.post('v1/intelbras/panels', params)

      return data
    },
    async show(_, id) {
      const {data} = await axios.get(`v1/intelbras/panels/${id}`)

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/intelbras/panels/${id}`, params)

      return data
    },
    async delete(_, id) {
      const {data} = await axios.delete(`v1/intelbras/panels/${id}`)

      return data
    },
    async addEntries(_, params) {
      const {data} = await axios.post('v1/intelbras/panels/add-entries', params)

      return data
    },
    async copyPassword(_, params) {
      const {data} = await axios.get(`v1/intelbras/panels/passwords/${params.id}`, {params: {field: params.field}})

      return data
    },
    async syncActions(_, id) {
      const { data } = await axios.post(`v1/intelbras/panels/update-capabilities`, { id: id });

      return data;
    },

    async syncStatus(_, id) {
      const { data } = await axios.post(`v1/intelbras/panels/update-summary`, { id: id });

      return data;
    },

    async syncEvents(_, id) {
      const { data } = await axios.post(`v1/intelbras/events/sync`, { id: id });

      return data;
    },

    async syncDevices(_, id) {
      const { data } = await axios.get(`v1/intelbras/panels/${id}/sync-devices`);

      return data;
    },

    async panelModels(_) {
      const { data } = await axios.get('v1/intelbras/panels/panel-models');

      return data;
    },

    async restart(_, params) {
      const { data } = await axios.post('v1/intelbras/panels/restart', params);

      return data;
    },

    async rebuild(_, params) {
      const { data } = await axios.post('v1/intelbras/panels/rebuild', params);

      return data;
    },

    async reconnect(_, params) {
      const { data } = await axios.post('v1/intelbras/panels/reconnect', params);

      return data;
    },

    async togglePgm(_, params) {
      return await axios.get('v1/intelbras/capabilities/pgm-toggle', {params});
    },

    async activateZone(_, params) {
      const { data } = await axios.get('v1/intelbras/capabilities/zone-activate', { params });

      return data;
    },

    async deactivateZone(_, params) {
      const { data } = await axios.get('v1/intelbras/capabilities/zone-deactivate', { params });

      return data;
    },

    async arm(_, params) {
      const { data } = await axios.get('v1/intelbras/capabilities/arm', { params });

      return data;
    },

    clear({commit}) {
      commit('setData', [])
    }
  },
}
